export class BaseOptionDefinition {
  public value: string
  public description: string
  public idml: string
  public disabled: string
  public exclusiveValue: string
  public fontColor: string
  public extras: ExtraValueDefinition
  public icon: string

  constructor(baseOptionDefinition: BaseOptionDefinition) {
    this.value = baseOptionDefinition.value
    this.description = baseOptionDefinition.description
    this.idml = baseOptionDefinition.idml
    this.disabled = baseOptionDefinition.disabled
    this.exclusiveValue = baseOptionDefinition.exclusiveValue
    this.fontColor = baseOptionDefinition.fontColor
    this.extras = baseOptionDefinition.extras
    this.icon = baseOptionDefinition.icon
  }
}

export interface ExtraValueDefinition {
  extras: ExtraDefinition[]
}

export interface ExtraDefinition {
  name: string
  value: string
}
